import {IAdmin} from '../models/Admin';

export const ADD_ADMIN = 'ADD_ADMIN';
export const ADD_ADMIN_SUCCESS = 'ADD_ADMIN_SUCCESS';
export const ADD_ADMIN_ERROR = 'ADD_ADMIN_ERROR';

export const ADD_ADMIN_EMAIL = 'ADD_ADMIN_EMAIL';
export const ADD_ADMIN_EMAIL_SUCCESS = 'ADD_ADMIN_EMAIL_SUCCESS';
export const ADD_ADMIN_EMAIL_ERROR = 'ADD_ADMIN_EMAIL_ERROR';

export const FETCH_ADMIN_LIST = 'FETCH_ADMIN_LIST';
export const FETCH_ADMIN_LIST_SUCCESS = 'FETCH_ADMIN_LIST_SUCCESS';
export const FETCH_ADMIN_LIST_ERROR = 'FETCH_ADMIN_LIST_ERROR';

export const REMOVE_ADMIN = 'REMOVE_ADMIN';
export const REMOVE_ADMIN_SUCCESS = 'REMOVE_ADMIN_SUCCESS';
export const REMOVE_ADMIN_ERROR = 'REMOVE_ADMIN_ERROR';

export interface AddAdmin {
  type: typeof ADD_ADMIN;
}

export interface AddAdminSuccess {
  type: typeof ADD_ADMIN_SUCCESS;
  payload: IAdmin;
}

export interface AddAdminError {
  type: typeof ADD_ADMIN_ERROR;
}

export interface FetchAdmins {
  type: typeof FETCH_ADMIN_LIST;
}

export interface FetchAdminsSuccess {
  type: typeof FETCH_ADMIN_LIST_SUCCESS;
  payload: IAdmin[];
}

export interface FetchAdminsError {
  type: typeof FETCH_ADMIN_LIST_ERROR;
}

export interface RemoveAdmin {
  type: typeof REMOVE_ADMIN;
}

export interface RemoveAdminSuccess {
  type: typeof REMOVE_ADMIN_SUCCESS;
  payload: string;
}

export interface RemoveAdminError {
  type: typeof REMOVE_ADMIN_ERROR;
}

export interface FetchAdmins {
  type: typeof FETCH_ADMIN_LIST;
}

export interface AddAdminEmail {
  type: typeof ADD_ADMIN_EMAIL;
}

export interface AddAdminEmailSuccess {
  type: typeof ADD_ADMIN_EMAIL_SUCCESS;
  payload: IAdmin;
}

export interface AddAdminEmailError {
  type: typeof ADD_ADMIN_EMAIL_ERROR;
}

export type AdminActions =
  | AddAdmin
  | AddAdminSuccess
  | AddAdminError
  | FetchAdmins
  | FetchAdminsSuccess
  | FetchAdminsError
  | RemoveAdmin
  | RemoveAdminError
  | RemoveAdminSuccess
  | AddAdminEmail
  | AddAdminEmailSuccess
  | AddAdminEmailError;
